import { useActiveAddress } from "@arweave-wallet-kit/react"
import { Button, Stack } from "@mui/material"
import { Plus } from "@untitled-ui/icons-react"
import { Link } from "react-router-dom"

export default function TopActions() {
  const connectedUser = useActiveAddress()

  return (
    <Stack direction={"row"} spacing={2}>
      {connectedUser && (
        <Link to="/my-account">
          <Button
            variant="contained"
            color="secondary"
            sx={() => ({
              color: "#fff",
              borderRadius: "4px",
              padding: "0.75rem 2.5rem",
              gap: "0.5rem",
            })}
          >
            My Pools
          </Button>
        </Link>
      )}
      <Link to="/add">
        <Button
          variant="contained"
          color="accent"
          sx={() => ({
            color: "#fff",
            borderRadius: "4px",
            padding: "0.6rem 2.5rem",
            gap: "0.5rem",
          })}
          startIcon={<Plus />}
        >
          Create Pool
        </Button>
      </Link>
    </Stack>
  )
}
